import { render } from "./AfterSalesIcon.vue?vue&type=template&id=2b3c56d9"
import script from "./AfterSalesIcon.vue?vue&type=script&lang=js"
export * from "./AfterSalesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AfterSalesIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b3c56d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b3c56d9', __exports__)) {
    api.reload('2b3c56d9', __exports__)
  }
  
  module.hot.accept("./AfterSalesIcon.vue?vue&type=template&id=2b3c56d9", () => {
    api.rerender('2b3c56d9', render)
  })

}


export default __exports__